import { Components, Theme } from '@mui/material';
import { getResponsiveFontSize } from '../../shared/utils';

export const getMuiTab = (theme: Theme): Components['MuiTab'] => ({
  styleOverrides: {
    root: {
      color: theme.palette.text.primary,
      fontSize: getResponsiveFontSize(theme.typography.pxToRem(18)),
      fontVariant: 'all-small-caps',
      fontWeight: theme.typography.fontWeightMedium,
      padding: '0 16px',
      minHeight: 32,
      display: 'inline-flex',
      flexDirection: 'row',
      '&.Mui-selected': {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.text.primary,
      },
    },
  },
});
